import BaseModelAPI from '../BaseModelAPI';

export default class ReceiptFromProductionList extends BaseModelAPI {

	static entity = 'receiptfromproductionlist'
	static entityName = 'receiptfromproduction';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
